module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.cItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "simple-flow-item-wrapper weex-ct weex-div",
      staticStyle: {
        "width": "10rem"
      },
      attrs: {
        "accessible": true,
        "aria-label": ((item.title) + "," + (item.desc ? item.desc : '') + "," + (item.date ? item.date : '') + "," + (item.highlight ? '已完成' : '等待完成')),
        "weex-type": "div"
      }
    }, [(_vm.leftContent) ? _c('div', {
      staticClass: "left-content-wrap weex-ct weex-div",
      style: (_vm._px2rem(_vm.leftContentStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [_vm._t("leftContent", [(item.leftContentDate) ? _c('p', {
      staticClass: "left-text-date weex-el weex-text",
      class: item.__titleTextClass__,
      style: (_vm._processExclusiveStyle(item.__titleStyle__, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.leftContentDate))]) : _vm._e()], {
      "item": item
    })], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "rightContent",
      refInFor: true,
      staticClass: " weex-ct weex-div",
      staticStyle: {
        "-webkit-box-flex": "1",
        "-webkit-flex": "1",
        "flex": "1"
      },
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "title flex-row weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "line weex-ct weex-div",
      class: item.__titleLineClass__,
      style: (_vm._px2rem(item.__lineStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "point weex-ct weex-div",
      class: item.__pointClass__,
      style: (_vm._px2rem(item.__pointStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [(item.highlight && !_vm._isColmo) ? _c('div', {
      staticClass: "highlightInner weex-ct weex-div",
      style: ({
        backgroundColor: item.__pointStyle__.innerBackgroundColor ? item.__pointStyle__.innerBackgroundColor : _vm._isDiablo ? '#0490D3' : '#00a4f2'
      }),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-title full-rest weex-el weex-text",
      class: item.__titleTextClass__,
      style: (_vm._processExclusiveStyle(item.__titleStyle__, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content flex-row weex-ct weex-div",
      class: item.__contentClass__,
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "line weex-ct weex-div",
      class: item.__contentLineClass__,
      style: (_vm._px2rem(item.__lineStyle__, 75)),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-rest weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(item.desc) ? _c('p', {
      staticClass: "text-desc weex-el weex-text",
      style: ({
        width: _vm._px2rem(_vm.rightContentWidth ? _vm.rightContentWidth + 'px' : 'auto', 75)
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e(), _vm._v(" "), (item.date) ? _c('p', {
      staticClass: "text-date weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.date))]) : _vm._e()])])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7826a4e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7826a4e4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-simple-flow/index.vue
// module id = 642
// module chunks = 0 1